// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import Button from '../buttons/Button';
import Icon from '../icons/Icon';

// Styles
import './SearchClearButton.scss';

type Props = {
    show: boolean;
    canClear: boolean;
    onMouseDown?: () => void;
    onClick?: () => void;
};

const SearchClearButton = ({ show, canClear, onMouseDown, onClick }: Props) => {
    if (!show) return null;

    const iconName = canClear ? 'search-clear' : 'search-magnifying-glass';

    return (
        <Button
            className={classNames('SearchClearButton', { clear: canClear })}
            onMouseDown={onMouseDown}
            onClickFn={onClick}
        >
            <Icon name={iconName} />
        </Button>
    );
};

export default SearchClearButton;
